module.exports = __webpack_public_path__ + "assets/total_leads_worked.236510c2.svg";